export const PUBLISH_WORKSPACE_PANELS = [
  { id: "preview", label: "Preview", icon: "fas fa-file-alt" },
  { id: "publish", label: "Publish", icon: "fas fa-globe" },
  { id: "reviewers", label: "Reviewers", icon: "fas fa-user-check" },
  { id: "approvers", label: "Approvers", icon: "fas fa-user-shield" },
  { id: "associatedDocs", label: "Associated docs", icon: "fas fa-link" },
  { id: "quiz", label: "Quiz", icon: "fas fa-question-circle" },
  { id: "versions", label: "Version history", icon: "fas fa-history" },
  { id: "auditLog", label: "Audit log", icon: "fas fa-clipboard-list" },
];
